import { render, staticRenderFns } from "./OpportunitiesForm.vue?vue&type=template&id=57c1b17a&scoped=true&"
import script from "./OpportunitiesForm.vue?vue&type=script&lang=js&"
export * from "./OpportunitiesForm.vue?vue&type=script&lang=js&"
import style0 from "./OpportunitiesForm.vue?vue&type=style&index=0&id=57c1b17a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c1b17a",
  null
  
)

export default component.exports